<template>
  <v-toolbar app extension-height="0" fixed overflow>
    <v-toolbar-items v-if="$route.name == 'run'">
      <v-btn icon @click="$router.go(-1)" style="margin-left: -6px;">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </v-toolbar-items>
    <v-toolbar-side-icon @click.stop="$store.dispatch('toggleDrawer');" v-else></v-toolbar-side-icon>
    <v-toolbar-title class="headline text-uppercase">
      <!-- <span>EUHFORIA</span>
      <span class="font-weight-light">online</span>-->
      <span class="font-weight-light">{{ $store.getters.title }}</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <AppHelp />
    </v-toolbar-items>
    <v-progress-linear
      :active="$wait.is('busy')"
      :indeterminate="true"
      class="ma-0"
      height="4"
      slot="extension"
      style="top: -2px;"
    >Progress?</v-progress-linear>
  </v-toolbar>
</template>

<style>
.v-toolbar__extension {
  padding: 0px !important;
}
.v-progress-linear {
  -moz-transform: scale(1, -1);
  -webkit-transform: scale(1, -1);
  -o-transform: scale(1, -1);
  -ms-transform: scale(1, -1);
  transform: scale(1, -1);
}
</style>

<script>
import AppHelp from '@/components/AppHelp.vue';

export default {
  components: { AppHelp },
};
</script>
